
    import { Component, Vue } from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import Filters from '@/components/table/Filters.vue';
    import Table from "@/components/table/Table.vue";
    import {ApiRepository} from '@/api';

    @Component({
        components: {
            Layout,
            Filters,
            Table
        },
    })
    export default class User extends Vue {
        private data: any = [];

        private keys = {
            id: '#',
            email: 'Email',
            role: 'Rola',
            'partner.name': 'Partner',
        };

        private filterKeys = {
            id: '#',
            email: 'Email',
            role: 'Rola',
        };

        private selects = {
            role: [
                'admin',
                'partner',
            ],
        };

        private excludedSorters = ['partner.name'];

        private links = [
            {
                url: '/users/edit/:param:',
                image: require('@/assets/image/edit.svg'),
            },
            {
                url: '/users/delete/:param:',
                image: require('@/assets/image/delete.svg'),
                confirm: true,
                confirmMessage: 'Naozaj chcete odstraniť uživateľa?',
            },
        ];

        private filters = '';

        // paging
        private pager = {
            count: 0,
            take: 0,
            page: 0,
            totalCount: 0
        };

        // sorting
        private key = '';
        private sort = '';

        public async mounted() {
            await this.sendRequest();
        }

        private async sendRequest(params: object = {}) {
            params = {
                relations: ['partner'],
                ...params
            };

            let response = await ApiRepository.getUsers(params);
            this.data = response.data;
            this.pager = {
                count: response.count,
                take: response.take,
                page: response.page,
                totalCount: response.totalCount
            };
        }

        private async setFilter(filters: any) {
            let strFilter: any = [];

            if (filters) {
                Object.keys(filters).forEach((key: string) => {
                    strFilter.push(key + ':' + filters[key]);
                });
            }
            strFilter = strFilter.join(',');

            this.filters = strFilter;

            await this.sendRequest({
                sort: this.key || 'email',
                order: this.sort ? 'ASC' : 'DESC',
                filters: strFilter
            });
        }

        private async changeOptions(data: any) {
            let response = await ApiRepository.getUsers({
                sort: data.key,
                order: data.sort ? 'ASC' : 'DESC',
                filters: this.filters,
            });

            this.data = response.data;

            this.pager.page = data.page || this.pager.page;
            this.key = data.key;
            this.sort = data.sort;

            await this.sendRequest({
                page: this.pager.page,
                sort: this.key,
                order: this.sort ? 'ASC' : 'DESC',
                filters: this.filters
            });
        }

        private async changePage(page: Number) {
            await this.changeOptions({
                key: this.key || 'id',
                page: page
            });
        }
    }
